import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './FlightSafetyPage.css';

const GROUND_PREP_PAX_CERT_ITEMS = [
  'flightSafety.groundPrepItem1',
  'flightSafety.groundPrepItem2',
  'flightSafety.groundPrepItem3',
  'flightSafety.groundPrepItem4'
];

const GROUND_PREP_HANDLING_PHASES = [
  {
    titleKey: 'flightSafety.groundPrepPhase1Title',
    itemKeys: [
      'flightSafety.groundPrepPhase1Item1',
      'flightSafety.groundPrepPhase1Item2',
      'flightSafety.groundPrepPhase1Item3'
    ]
  },
  {
    titleKey: 'flightSafety.groundPrepPhase2Title',
    itemKeys: [
      'flightSafety.groundPrepPhase2Item1',
      'flightSafety.groundPrepPhase2Item2',
      'flightSafety.groundPrepPhase2Item3'
    ]
  },
  {
    titleKey: 'flightSafety.groundPrepPhase3Title',
    itemKeys: [
      'flightSafety.groundPrepPhase3Item1',
      'flightSafety.groundPrepPhase3Item2'
    ]
  },
  {
    titleKey: 'flightSafety.groundPrepPhase4Title',
    itemKeys: [
      'flightSafety.groundPrepPhase4Item1',
      'flightSafety.groundPrepPhase4Item2',
      'flightSafety.groundPrepPhase4Item3',
      'flightSafety.groundPrepPhase4Item4',
      'flightSafety.groundPrepPhase4Item5',
      'flightSafety.groundPrepPhase4Item6'
    ]
  }
];

const FlightSafetyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flight-safety-page">
      <div className="flight-safety-header">
        <h1>{t('flightSafety.title')}</h1>
        <p>{t('flightSafety.subtitle')}</p>
      </div>

      <div className="container">
        <div className="flight-safety-content">
          <section className="flight-safety-intro">
            <h2>{t('flightSafety.paxCertTitle')}</h2>
            <p>{t('flightSafety.paxCertIntro')}</p>
          </section>

          <section className="flight-safety-requirements">
            <h2>{t('flightSafety.requirementsTitle')}</h2>
            <p>{t('flightSafety.requirementsIntro')}</p>

            <div className="requirement-card">
              <div className="requirement-number">1</div>
              <div className="requirement-body">
                <h3>{t('flightSafety.groundPrepTitle')}</h3>
                <p>{t('flightSafety.groundPrepDesc')}</p>
                <h4 className="ground-prep-subtitle">{t('flightSafety.groundPrepPaxCertSubtitle')}</h4>
                <ul>
                  {GROUND_PREP_PAX_CERT_ITEMS.map((key) => (
                    <li key={key}>{t(key)}</li>
                  ))}
                </ul>
                <h4 className="ground-prep-subtitle">{t('flightSafety.groundPrepHandlingTitle')}</h4>
                <p className="ground-prep-handling-intro">{t('flightSafety.groundPrepHandlingIntro')}</p>
                {GROUND_PREP_HANDLING_PHASES.map((phase) => (
                  <div key={phase.titleKey} className="ground-prep-phase">
                    <h5>{t(phase.titleKey)}</h5>
                    <ul>
                      {phase.itemKeys.map((itemKey) => (
                        <li key={itemKey}>{t(itemKey)}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            <div className="requirement-card">
              <div className="requirement-number">2</div>
              <div className="requirement-body">
                <h3>{t('flightSafety.flightTrainingTitle')}</h3>
                <p>{t('flightSafety.flightTrainingDesc')}</p>
                <ul>
                  <li>{t('flightSafety.flightTrainingItem1')}</li>
                  <li>{t('flightSafety.flightTrainingItem2')}</li>
                  <li>{t('flightSafety.flightTrainingItem3')}</li>
                </ul>
              </div>
            </div>

            <div className="requirement-card">
              <div className="requirement-number">3</div>
              <div className="requirement-body">
                <h3>{t('flightSafety.examTitle')}</h3>
                <p>{t('flightSafety.examDesc')}</p>
                <ul>
                  <li>{t('flightSafety.examItem1')}</li>
                  <li>{t('flightSafety.examItem2')}</li>
                  <li>{t('flightSafety.examItem3')}</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="flight-safety-footer">
            <p>{t('flightSafety.conclusion')}</p>
            <p>{t('flightSafety.pilotChecklistHighlights')}</p>
            <p>{t('flightSafety.passengerBriefingHighlights')}</p>
            <Link to="/booking" className="btn btn-primary">
              {t('flightSafety.bookNow')}
            </Link>
            <Link to="/easa-charter" className="btn btn-secondary" style={{ marginLeft: '10px' }}>
              {t('flightSafety.readCharterCta')}
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default FlightSafetyPage;
